import { bool, shape, string } from "prop-types";

export const unitShape = shape({
  area: string.isRequired,
  availableDate: string,
  bathrooms: string.isRequired,
  bedrooms: string.isRequired,
  floor: string.isRequired,
  floorPlan: string.isRequired,
  id: string.isRequired,
  image: string.isRequired,
  isAvailable: bool.isRequired,
  matterportId: string,
  price: string,
  sightmapEmbed: string,
  unitNumber: string.isRequired,
  url: string.isRequired,
});
